import {useContext} from 'react'
import { Context } from './context'
import {useMapHandler, usePrevUri, useRegion, useRegions} from 'helpers'

export const ContextProvider = ({ children }) => {
    const { data: regions } = useRegions()
    const { region, setRegion } = useRegion()
    const { prevPath } = usePrevUri()
    const mapOptions = useMapHandler(regions?.data?.data)

    const value = {
        region,
        prevPath,
        setRegion,
        regions,
        mapOptions
    }


    return <Context.Provider value={value} children={children} />
}

export const useAppContext = ()=> useContext(Context)
